import Vue from 'vue';
import groupBy from 'lodash/groupBy';
import normalize from '@/lib/normalize';
import Users from '@/resources/users';
import PaginatedList from './mixins/paginated-list';

export default {
  namespaced: true,
  ...PaginatedList(Users, {
    state: {
      flash: null,
      flashType: null,
      flashIcon: null,
      user: null
    },

    /* eslint no-param-reassign: ["error", { "props": false }] */
    mutations: {
      setFlashMessage(state, { message, type, icon }) {
        state.flash = message;
        state.flashType = type;
        state.flashIcon = icon;
      },
      parseResponseUserData(state, response) {
        const res = normalize(response, { 'licence-area-and-zones': true });
        Vue.set(state, 'user', res);
      },
      editUser(state, user) {
        Vue.set(state, 'user', user);
      }
    },
    getters: {
      sortedUsers(state) {
        return groupBy(state.data, user => user.role);
      },
      licenceAreaAndZones(state) {
        return state.user && state.user.licenceAreaAndZones;
      }
    },
    actions: {
      removeUser({ dispatch }, payload) {
        Users.delete({ id: payload.userId }).then(
          () => {
            dispatch('setFlashMessage', { message: 'User has been deleted successfully.' });
          },
          () => {
            dispatch('setFlashMessage', {
              message: 'Something went wrong.',
              type: 'error',
              icon: 'warning'
            });
          }
        );
      },
      setFlashMessage(
        { commit },
        { message, type = 'success', icon = 'check_circle', time = 3000 }
      ) {
        commit('setFlashMessage', { message, type, icon });
        setTimeout(() => commit('setFlashMessage', { message: null }), time);
      },
      fetchUserData({ commit }, { userId }) {
        const action = Users.get({ id: userId, include: 'licence_area_and_zones' });

        action.then(response => {
          commit('parseResponseUserData', response.data);
        });

        return action;
      }
    }
  })
};
